import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Enterprise } from 'models/Enterprises';
import BrandingLogo from 'components/BrandingLogo';

import './EnterpriseHeader.styles.scss';
import './EnterpriseHeader.styles.responsive.scss';

type EnterpriseHeaderProps = {
  className?: string;
  enterprise: Partial<Enterprise>;
};

const EnterpriseHeader: React.FC<EnterpriseHeaderProps> = (props) => {
  const { className, enterprise } = props;

  const { brandName, logo, mobileLogo } = enterprise;

  const brandingLogos = useMemo(
    () => ({ logo, mobileLogo }),
    [logo, mobileLogo],
  );

  const classes = classNames('enterprise-header', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <h1>{t('enterpriseNameDashboard', { brandName })}</h1>
      <BrandingLogo brandingLogos={brandingLogos} height={60} />
    </div>
  );
};

export default EnterpriseHeader;
